"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.number.constructor");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.promise");

require("core-js/modules/es.promise.finally");

require("core-js/modules/es.regexp.constructor");

require("core-js/modules/es.regexp.exec");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/es.string.replace");

require("core-js/modules/es.string.search");

require("core-js/modules/web.dom-collections.iterator");

require("core-js/modules/web.url");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.generateUUID = generateUUID;
exports.generateTRMRGUID = generateTRMRGUID;
exports.cookie = cookie;
exports.flattenObj = flattenObj;
exports.flattenKeys = flattenKeys;
exports.extend = extend;
exports.uniq = uniq;
exports.decodeHtmlEntities = decodeHtmlEntities;
exports.isNullOrEmpty = isNullOrEmpty;
exports.parseUri = parseUri;
exports.debounce = debounce;
exports.deferred = deferred;
exports.jsonHeaders = jsonHeaders;
exports.throwOn = throwOn;
exports.debouncePromise = debouncePromise;
exports.flushAsyncIterator = flushAsyncIterator;
exports.requestInterval = requestInterval;
exports.frames = frames;
exports.jobQueue = jobQueue;
exports.memoize = memoize;

_Object$defineProperty(exports, "deprecatedLogger", {
  enumerable: true,
  get: function get() {
    return _deprecatedEndpointsLogger.deprecatedLogger;
  }
});

_Object$defineProperty(exports, "timeZoneOffsetInterceptor", {
  enumerable: true,
  get: function get() {
    return _timeZoneOffsetInterceptor.init;
  }
});

exports.waitAnimationFrame = exports.regexpSerializer = exports.mask = exports.constants = exports.omnibus = void 0;

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/map"));

var _setInterval2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/set-interval"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs3/regenerator"));

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/asyncToGenerator"));

var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/promise"));

var _setTimeout2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/set-timeout"));

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/json/stringify"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectSpread2"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/typeof"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _asyncIterator2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/asyncIterator"));

var _omnibus = _interopRequireWildcard(require("./omnibus"));

var _constants = _interopRequireWildcard(require("./constants"));

var _mask = _interopRequireWildcard(require("./mask"));

var _regexpSerializer = _interopRequireWildcard(require("./regexp-serializer"));

var _deprecatedEndpointsLogger = require("./deprecated-endpoints-logger");

var _timeZoneOffsetInterceptor = require("./time-zone-offset-interceptor");

var omnibus = _omnibus;
exports.omnibus = omnibus;
var constants = _constants;
exports.constants = constants;
var mask = _mask;
exports.mask = mask;
var regexpSerializer = _regexpSerializer;
exports.regexpSerializer = regexpSerializer;

function generateUUID() {
  var d = new Date().getTime();

  if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
    d += performance.now();
  }

  var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c == 'x' ? r : r & 0x3 | 0x8).toString(16);
  });
  return uuid;
}

function generateTRMRGUID(uuid) {
  if (!uuid) {
    uuid = generateUUID();
  }

  return uuid.replace(/-/g, '');
}

function cookie(key, val, path, infinite) {
  if (val === undefined) {
    var _RegExp$exec;

    return ((_RegExp$exec = new RegExp("(^|; )".concat(key, "=([^;]*)")).exec(document.cookie)) !== null && _RegExp$exec !== void 0 ? _RegExp$exec : [])[2];
  }

  var pathSeg = path ? "; path=".concat(path) : '';
  var expiresSeg = infinite ? '; expires=Fri, 31 Dec 9999 23:59:59 GMT' : '';

  if (val === null) {
    var _context;

    document.cookie = (0, _concat.default)(_context = "".concat(key, "=; expires=Thu, 01 Jan 1970 00:00:01 GMT")).call(_context, pathSeg);
  } else {
    var _context2, _context3, _context4;

    document.cookie = (0, _concat.default)(_context2 = (0, _concat.default)(_context3 = (0, _concat.default)(_context4 = "".concat(key, "=")).call(_context4, val)).call(_context3, pathSeg)).call(_context2, expiresSeg);
  }

  return undefined;
}

function flattenObj(obj, filter) {
  var flat = {};

  function traverse(subObj, key) {
    var compound;
    var val;

    for (var _prop in subObj) {
      if (Object.prototype.hasOwnProperty.call(subObj, _prop)) {
        var _context5;

        compound = key ? (0, _concat.default)(_context5 = "".concat(key, ".")).call(_context5, _prop) : _prop;
        val = subObj[_prop];

        if ((0, _typeof2.default)(val) === 'object') {
          traverse(val, compound);
        } else {
          if (filter && !filter(subObj, _prop, compound)) {
            continue;
          }

          flat[compound] = val;
        }
      }
    }
  }

  traverse(obj);
  return flat;
}

function flattenKeys(obj, filter) {
  var flat = [];

  function traverse(subObj, key) {
    var compound;

    for (var _prop2 in subObj) {
      if (Object.prototype.hasOwnProperty.call(subObj, _prop2)) {
        var _context6;

        compound = key ? (0, _concat.default)(_context6 = "".concat(key, ".")).call(_context6, _prop2) : _prop2;

        if ((0, _typeof2.default)(subObj[_prop2]) === 'object') {
          traverse(subObj[_prop2], compound);
        } else {
          if (filter && !filter(subObj, _prop2, compound)) {
            continue;
          }

          flat.push(compound);
        }
      }
    }
  }

  traverse(obj);
  return flat;
}

function extend() {
  throw new Error('Not implemented.');
}

function uniq(a) {
  var seen = {};
  var out = [];
  var len = a.length;
  var j = 0;

  for (var i = 0; i < len; i++) {
    var item = a[i];

    if (seen[item] !== 1) {
      seen[item] = 1;
      out[j++] = item;
    }
  }

  return out;
}

function decodeHtmlEntities(str) {
  var txt = document.createElement('textarea');
  txt.innerHTML = str;
  return txt.value;
}

function isNullOrEmpty(str) {
  return typeof str === 'undefined' || str === null || str === '';
}

function parseUri(href) {
  var _window$URL;

  var url = {};

  if (((_window$URL = window.URL) === null || _window$URL === void 0 ? void 0 : _window$URL.prototype) && 'href' in window.URL.prototype) {
    url = new window.URL(href);
    return url;
  }

  url = document.createElement('a');
  url.href = href;
  var fakeUrlObject = {
    hash: url.hash,
    host: url.host,
    hostname: url.hostname,
    href: url.href,
    origin: url.origin,
    password: url.password,
    pathname: url.pathname,
    port: url.port,
    protocol: url.protocol,
    search: url.search,
    searchParams: url.searchParams || null,
    username: url.username
  };
  return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, fakeUrlObject), {}, {
    toJSON: function toJSON() {
      return (0, _stringify.default)(fakeUrlObject);
    }
  });
}

function debounce(fn) {
  var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
  var timeout;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var ctx = this;
    clearTimeout(timeout);
    timeout = (0, _setTimeout2.default)(function () {
      return fn.apply(ctx, args);
    }, wait);
  };
}

function deferred() {
  var _context7, _context9;

  var resolveAcc;
  var rejectAcc;
  var prom = new _promise.default(function (resolve, reject) {
    resolveAcc = resolve;
    rejectAcc = reject;
  });
  return {
    catch: (0, _bind.default)(_context7 = prom.catch).call(_context7, prom),
    finally: function _finally() {
      var _context8;

      return (0, _bind.default)(_context8 = prom.finally).call(_context8, prom);
    },
    reject: function reject(error) {
      return rejectAcc(error);
    },
    resolve: function resolve(value) {
      return resolveAcc(value);
    },
    then: (0, _bind.default)(_context9 = prom.then).call(_context9, prom)
  };
}

function jsonHeaders() {
  var headers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _objectSpread2.default)({
    Accept: 'application/json, text/plain, */*',
    'Content-Type': 'application/json;charset=UTF-8'
  }, headers);
}

function throwOn(_x, _x2) {
  return _throwOn.apply(this, arguments);
}

function _throwOn() {
  _throwOn = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6(response, statusCodeRejector) {
    var status, shouldReject;
    return _regenerator.default.wrap(function _callee6$(_context16) {
      while (1) {
        switch (_context16.prev = _context16.next) {
          case 0:
            status = response.status;
            shouldReject = typeof statusCodeRejector === 'number' ? statusCodeRejector === status : statusCodeRejector(status);

            if (!shouldReject) {
              _context16.next = 4;
              break;
            }

            return _context16.abrupt("return", _promise.default.reject(response));

          case 4:
            return _context16.abrupt("return", _promise.default.resolve(response));

          case 5:
          case "end":
            return _context16.stop();
        }
      }
    }, _callee6);
  }));
  return _throwOn.apply(this, arguments);
}

function debouncePromise(fn) {
  var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
  var defer;
  var timer;

  function flush() {
    var thisDeferred = defer;
    clearTimeout(Number(timer));

    if (thisDeferred) {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      _promise.default.resolve(fn.apply(this, args)).then(thisDeferred.resolve, thisDeferred.reject);
    }

    defer = null;
  }

  return /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
    var _bindInstanceProperty2, _context10;

    var _len3,
        args,
        _key3,
        _args = arguments;

    return _regenerator.default.wrap(function _callee$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            if (defer) {
              clearTimeout(Number(timer));
            } else {
              defer = deferred();
            }

            for (_len3 = _args.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
              args[_key3] = _args[_key3];
            }

            timer = (0, _setTimeout2.default)((_bindInstanceProperty2 = (0, _bind.default)(flush)).call.apply(_bindInstanceProperty2, (0, _concat.default)(_context10 = [flush, this]).call(_context10, args)), wait);
            return _context11.abrupt("return", defer);

          case 4:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee, this);
  }));
}

function flushAsyncIterator(_x3) {
  return _flushAsyncIterator.apply(this, arguments);
}

function _flushAsyncIterator() {
  _flushAsyncIterator = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee7(iterator) {
    var result, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, item;

    return _regenerator.default.wrap(function _callee7$(_context17) {
      while (1) {
        switch (_context17.prev = _context17.next) {
          case 0:
            result = [];
            _iteratorNormalCompletion = true;
            _didIteratorError = false;
            _context17.prev = 3;
            _iterator = (0, _asyncIterator2.default)(iterator);

          case 5:
            _context17.next = 7;
            return _iterator.next();

          case 7:
            _step = _context17.sent;
            _iteratorNormalCompletion = _step.done;
            _context17.next = 11;
            return _step.value;

          case 11:
            _value = _context17.sent;

            if (_iteratorNormalCompletion) {
              _context17.next = 18;
              break;
            }

            item = _value;
            result.push(item);

          case 15:
            _iteratorNormalCompletion = true;
            _context17.next = 5;
            break;

          case 18:
            _context17.next = 24;
            break;

          case 20:
            _context17.prev = 20;
            _context17.t0 = _context17["catch"](3);
            _didIteratorError = true;
            _iteratorError = _context17.t0;

          case 24:
            _context17.prev = 24;
            _context17.prev = 25;

            if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
              _context17.next = 29;
              break;
            }

            _context17.next = 29;
            return _iterator.return();

          case 29:
            _context17.prev = 29;

            if (!_didIteratorError) {
              _context17.next = 32;
              break;
            }

            throw _iteratorError;

          case 32:
            return _context17.finish(29);

          case 33:
            return _context17.finish(24);

          case 34:
            return _context17.abrupt("return", result);

          case 35:
          case "end":
            return _context17.stop();
        }
      }
    }, _callee7, null, [[3, 20, 24, 34], [25,, 29, 33]]);
  }));
  return _flushAsyncIterator.apply(this, arguments);
}

function requestInterval(fn, delay) {
  var animationId;

  var loop = function loop() {
    if (animationId) {
      cancelAnimationFrame(animationId);
    }

    animationId = requestAnimationFrame(fn);
  };

  var id = (0, _setInterval2.default)(loop, delay);
  return function () {
    clearInterval(id);
    cancelAnimationFrame(animationId);
  };
}

function frames() {
  var pedings = {};
  return /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(name) {
      return _regenerator.default.wrap(function _callee2$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              return _context12.abrupt("return", new _promise.default(function (resolve) {
                if (pedings[name]) {
                  window.cancelAnimationFrame(pedings[name]);
                  pedings[name] = null;
                }

                pedings[name] = window.requestAnimationFrame(function () {
                  pedings[name] = null;
                  resolve();
                });
              }));

            case 1:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x4) {
      return _ref2.apply(this, arguments);
    };
  }();
}

var waitAnimationFrame = /*#__PURE__*/function () {
  var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
    return _regenerator.default.wrap(function _callee3$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            return _context13.abrupt("return", new _promise.default(function (resolve) {
              return requestAnimationFrame(resolve);
            }));

          case 1:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee3);
  }));

  return function waitAnimationFrame() {
    return _ref3.apply(this, arguments);
  };
}();

exports.waitAnimationFrame = waitAnimationFrame;

function jobQueue(job, time) {
  var releaser;
  releaser = (0, _setTimeout2.default)( /*#__PURE__*/function () {
    var _timerLoop = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5(prevResult) {
      var result;
      return _regenerator.default.wrap(function _callee5$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              _context15.next = 2;
              return waitAnimationFrame();

            case 2:
              _context15.next = 4;
              return job(prevResult);

            case 4:
              result = _context15.sent;
              releaser = (0, _setTimeout2.default)( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4() {
                return _regenerator.default.wrap(function _callee4$(_context14) {
                  while (1) {
                    switch (_context14.prev = _context14.next) {
                      case 0:
                        return _context14.abrupt("return", timerLoop(result));

                      case 1:
                      case "end":
                        return _context14.stop();
                    }
                  }
                }, _callee4);
              })), time);

            case 6:
            case "end":
              return _context15.stop();
          }
        }
      }, _callee5);
    }));

    function timerLoop(_x5) {
      return _timerLoop.apply(this, arguments);
    }

    return timerLoop;
  }(), time);
  return function () {
    return clearTimeout(releaser);
  };
}

var _window = window,
    performance = _window.performance;

function memoize(func, timeout, resolver) {
  var resultTime;
  var cache = new _map.default();

  var memoized = function memoized() {
    var key = resolver ? resolver.apply(void 0, arguments) : arguments.length <= 0 ? undefined : arguments[0];

    if (cache.has(key) && (timeout ? performance.now() - resultTime <= timeout : true)) {
      return cache.get(key);
    }

    var result = func.apply(void 0, arguments);

    if (timeout) {
      resultTime = performance.now();
    }

    cache.set(key, result);
    return result;
  };

  memoized.release = function () {
    return cache.clear();
  };

  return memoized;
}
